export const SKIP_NAV_TARGET_ID = 'skip-nav-target-id';

export const SkipNavTarget = () => {
    return <div id={SKIP_NAV_TARGET_ID} />;
};
